import * as React from "react";

import { ViewportSyncMode, ZoomMode } from "../messaging/commands";
import { PlotTool } from "../plotTools/PlotTool";

import { PlotPanelContext, Region } from "./PlotPanelContext";

export function PlotPanelProvider({ children }: React.PropsWithChildren) {
  const [activeTool, setActiveTool] = React.useState<PlotTool>(PlotTool.Move);
  const [viewportSyncMode, setViewportSyncMode] =
    React.useState<ViewportSyncMode>("x");
  const [isLegendShown, setIsLegendShown] = React.useState(true);
  const [selectedRegion, setSelectedRegion] = React.useState<Region | null>(
    null,
  );
  const [zoomMode, setZoomMode] = React.useState<ZoomMode>("x");

  React.useEffect(
    function resetSelectedRegionWhenToolChanges() {
      setSelectedRegion(null);
    },
    [activeTool, setSelectedRegion],
  );

  return (
    <PlotPanelContext.Provider
      value={{
        activeTool,
        setActiveTool,
        viewportSyncMode,
        setViewportSyncMode,
        isLegendShown,
        setIsLegendShown,
        selectedRegion,
        setSelectedRegion,
        zoomMode,
        setZoomMode,
      }}
    >
      {children}
    </PlotPanelContext.Provider>
  );
}
